module.exports = "<div class=\"savedsearch-update form-field\" ng-show=filtersChanged()> <button ng-click=saveSearch() ng-show=canEdit class=button-alpha type=button translate> set.update_savedsearch </button> <button ng-click=resetSearch() class=button-link type=button translate> set.reset_savedsearch </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/savedsearches/savedsearch-update.html
// module id = 790
// module chunks = 0